module.exports = __webpack_public_path__ + "img/repair.56793fe7.png";